import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from 'recharts';
import { useTheme } from '../../../styles/ThemeProvider';
import { buildTooltipStyle } from './tooltipStyle';

export const ComparisonBar = ({ data, xKey = 'label', series = [], yFormatter, stacked = false }) => {
  const { theme } = useTheme();
  const tip = buildTooltipStyle(theme);
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid stroke={theme.color.border} strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey={xKey} stroke={theme.color.muted} fontSize={12} tickLine={false} />
        <YAxis stroke={theme.color.muted} fontSize={12} tickLine={false} axisLine={false} tickFormatter={yFormatter} />
        <Tooltip {...tip} formatter={yFormatter ? (v) => yFormatter(v) : undefined} />
        {series.length > 1 && <Legend wrapperStyle={{ fontSize: 12 }} />}
        {series.map((s, i) => (
          <Bar
            key={s.key}
            dataKey={s.key}
            name={s.label}
            fill={s.color || theme.chart.categorical[i % theme.chart.categorical.length]}
            stackId={stacked ? 'a' : undefined}
            radius={stacked ? 0 : [4, 4, 0, 0]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};
